/**
 * Shared constants and helpers for detecting / counting images in markdown text.
 *
 * These patterns intentionally match sweagentd's patterns in
 * runtime/src/model/capi/image-utils.ts so that the frontend and backend
 * agree on what constitutes an image reference.
 */

/** Matches markdown images: `![alt](url)` */
export const MARKDOWN_IMAGE_PATTERN = /!\[(.*?)\]\((.*?)\)/g

/** Matches HTML img tags: `<img src="url">` */
export const IMG_TAG_PATTERN = /<img\b[^>]*\bsrc="([^"]+)"[^>]*>/g

/**
 * Extract all image URLs from text using both markdown and HTML img patterns.
 * Returns an array of {url, alt} objects for each match.
 */
export function extractImageUrls(text: string): Array<{url: string; alt: string}> {
  const results: Array<{url: string; alt: string}> = []

  // Match markdown images: ![alt](url)
  for (const match of text.matchAll(MARKDOWN_IMAGE_PATTERN)) {
    const [, alt, url] = match
    if (url) {
      results.push({url, alt: alt || ''})
    }
  }

  // Match HTML img tags: <img src="url" alt="alt">
  for (const match of text.matchAll(IMG_TAG_PATTERN)) {
    const [fullMatch, url] = match
    if (url) {
      // Try to extract alt from the img tag
      const altMatch = fullMatch.match(/\balt="([^"]*)"/)
      results.push({url, alt: altMatch?.[1] || ''})
    }
  }

  return results
}
